var convert = require('./convert'),
    func = convert('get', require('../get'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/~/lodash/fp/get.js
// module id = 1339
// module chunks = 1